import React from 'react';
import { Card, Form, ColorPicker, Switch, Slider, Typography, Space } from 'antd';
import { useTheme } from '../../context/ThemeContext';

const { Title, Text } = Typography;

const ThemeSettings = () => {
  const { 
    primaryColor, 
    setPrimaryColor, 
    isDarkMode, 
    setIsDarkMode, 
    borderRadius, 
    setBorderRadius 
  } = useTheme();

  return (
    <Card title="Theme Customization" bordered={false}>
      <Form layout="vertical">
        <Form.Item label="Primary Color">
          <ColorPicker 
            showText 
            value={primaryColor} 
            onChange={(color) => setPrimaryColor(color.toHexString())} 
          />
        </Form.Item>

        <Form.Item label="Dark Mode">
          <Space>
            <Switch 
              checked={isDarkMode} 
              onChange={(checked) => setIsDarkMode(checked)} 
            />
            <Text>{isDarkMode ? 'Enabled' : 'Disabled'}</Text>
          </Space>
        </Form.Item>

        <Form.Item label={`Border Radius: ${borderRadius}px`}>
          <Slider 
            min={0} 
            max={20} 
            value={borderRadius} 
            onChange={(value) => setBorderRadius(value)} 
          />
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ThemeSettings;
